import {
  Box,
  Stack,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { useAnalyticsPageView } from '../../common/hooks/useAnalyticsPageView';

export const PageNotFound = () => {
  const { breakpoints } = useTheme();
  const isMobileScreen = useMediaQuery(breakpoints.down('md'));
  const translate = useTranslation();
  const history = useHistory();

  useAnalyticsPageView({
    pageName: 'Page Not Found',
    pagePath: '/pagenotfound',
    siteName: 'Online.ExternalTracking.UI',
  });

  return (
    <Box
      data-testid="page-not-found"
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        flex: 1,
        padding: '56px 24px 60px',
      }}
    >
      <Stack
        width={isMobileScreen ? '100%' : '650px'}
        alignItems="center"
        spacing={0.5}
      >
        <Typography variant="h3" sx={{ paddingBottom: '8px' }}>
          {translate('Page Not Found')}
        </Typography>
        <Typography variant="body1">
          {translate(
            'The page you are trying to access does not exist or cannot be displayed.'
          )}
        </Typography>
        <Button
          id="track-shipment-btn"
          onClick={() => history.push('/')}
          sx={{ marginTop: '24px', padding: '6px 14px' }}
          variant="contained"
        >
          {translate('Track a Shipment')}
        </Button>
      </Stack>
    </Box>
  );
};

export default PageNotFound;
